import { Matrix } from 'app/models/questions/Matrix'
import { QuestionComponent } from 'app/models/questions/QuestionComponent'
import {
  RadioMatrixComponent
} from 'app/modules/survey/survey-viewer/survey-question/types/radio-matrix/radio-matrix.component'
import { UntypedFormGroup } from '@angular/forms'

export class RadioMatrix extends Matrix {
  getDisplayComponent() {
    return new QuestionComponent(RadioMatrixComponent, this)
  }

  applyMaxAnswers(surveyForm: UntypedFormGroup) {
    if (!this.limitAnswersAmount) {
      return false
    }

    let matrixForm = surveyForm.controls[this.key]

    const rowKeys = this.extractRowKeysFromSurveyForm(surveyForm)
    const statementKeys = this.extractStatementKeysFromSurveyForm(surveyForm)

    if (this.maxAnswers.statements) {
      statementKeys.forEach(sKey => {
        let selectedStatementCountForColumn = 0
        rowKeys.forEach(rKey => {
          selectedStatementCountForColumn = this.countSelectedStatementsForColumn(matrixForm, rKey, sKey, selectedStatementCountForColumn)
          if (selectedStatementCountForColumn < this.maxAnswers.statements) {
            matrixForm.get(rKey).get(this.formControlName).get(sKey).enable({emitEvent: false})
          } else {
            this.disabledStatementsByColumnIfSelectionHitsThreshold(selectedStatementCountForColumn, matrixForm, sKey, surveyForm)
          }
        })
      })
    }
    return true
  }
}
